import { Container, FormControl, Grid, Paper, TextField } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { IRacingLicenseGradeList } from "../../_common/interface/racingLicenseGrade/iRacingLicenseGradeList";
import { IFilteringViewModel, ITableData } from "../../_common/interface/table";
import { PageHeader } from "../../_components/header/page.header";
import { CommonTable } from "../../_components/table/common.table";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { formTemplateService } from "../../_services/formTemplate.service";
import { FormTemplateManageDrawer } from "./formTemplate-manageDrawer";
import { FormTemplateSectionManage } from "./formTemplateSection.tsx/formTemplateSection-manage";
import { FormTemplateSectionList } from "./formTemplateSection.tsx/formTemplateSection-list";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { PrimaryButton } from "../../_components/button/primary.button";


export function FormTemplateIndex() {

    const [data, setData] = useState<ITableData<IRacingLicenseGradeList>>({ items: [], count: 0 });
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState<IFilteringViewModel>({
        name: '',
    });

    let navigate = useNavigate();

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'name',
                header: 'Name',
            },
            {
                accessorKey: 'formStatusName',
                header: 'Form Status Name',
            },
            {
                accessorKey: 'sectionOrder',
                header: 'Section Order',
                accessorFn: (rowData: any) => rowData.sectionOrder ?? "-"
            },
            {
                accessorKey: 'createdBy',
                header: 'Created By',
            },
            {
                accessorKey: 'modifiedBy',
                header: 'Modified By',
            },
        ],
        [],
    );

    useEffect(() => {
        fetchData();
    }, [filter]);

    function fetchData() {

        return formTemplateService.getAll({ ...filter })
            .then(
                data => {
                    setData(data);
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <Container>


            <PageHeader
                pageName="FormTemplates"
                buttonName="Form Templates"
                onClick={() => { navigate("Create") }}
                actionType="create"
            />
            <Paper>

                <CommonTable
                    columns={columns}
                    data={data}
                    onEdit={(id) => { navigate(`Edit/${id}`) }}
                    filter={filter}
                    setFilter={(_filter) => { setFilter({ ...filter, ..._filter }) }}
                    isLoading={isLoading}
                />
            </Paper>

            <Routes>

                <Route path="/Create" element={<FormTemplateManageDrawer emitOnSave={() => { navigate(""); fetchData(); }} emitOnClose={() => { navigate("") }} />} />

                <Route path="/Edit/:formTemplateId/" element={<FormTemplateManageDrawer emitOnSave={() => { navigate(""); fetchData(); }} emitOnClose={() => { navigate("") }} />} >
                    <Route path="CreateSection" element={<FormTemplateSectionManage emitOnSave={() => { }} />} />
                    <Route path="EditSection/:formTemplateSectionId" element={<FormTemplateSectionManage emitOnSave={() => { }} />} />
                    <Route path="" element={<FormTemplateSectionList />} />
                </Route>

            </Routes>

        </Container>
    );

}
